module.exports = __webpack_public_path__ + "img/google-play-badge.2bda5fd.png";


//////////////////
// WEBPACK FOOTER
// ./static/img_link/google-play-badge.png
// module id = Kigu
// module chunks = 1